module.exports = __webpack_public_path__ + "img/thumb_nbody.ca9334b5.jpg";